<template>
  <div class="login">
    <div class="login-form">
      <h3 class="title">量云消耗管理系统</h3>
      <div class="login-flex">
        <div class="login-type" :class="{ loginactive: loginType == 1 }" @click="changeLoginType(1)">密码登录</div>
        <div class="login-type" :class="{ loginactive: loginType == 2 }" @click="changeLoginType(2)">手机登录</div>
      </div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" v-show="loginType == 1">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="账号">
            <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" auto-complete="off" placeholder="密码"
            @keyup.enter.native="handleLogin">
            <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
          </el-input>
        </el-form-item>
        <el-form-item prop="code" v-if="captchaEnabled">
          <el-input v-model="loginForm.code" auto-complete="off" placeholder="验证码" style="width: 63%"
            @keyup.enter.native="handleLogin">
            <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
          </el-input>
          <div class="login-code">
            <img :src="codeUrl" @click="getCode" class="login-code-img" />
          </div>
        </el-form-item>
        <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>
        <el-form-item style="width:100%;">
          <el-button :loading="loading" size="medium" type="primary" style="width:100%;"
            @click.native.prevent="handleLogin">
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>
          <div style="float: right;" v-if="register">
            <router-link class="link-type" :to="'/register'">立即注册</router-link>
          </div>
        </el-form-item>
      </el-form>

      <el-form ref="loginForm2" :model="loginForm2" :rules="loginRules2" v-show="loginType == 2">
        <el-form-item prop="phonenumber">
          <el-input v-model="loginForm2.phonenumber" type="text" auto-complete="off" placeholder="手机号">
            <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="loginForm2.code" auto-complete="off" placeholder="验证码" style="width: 63%"
            @keyup.enter.native="handleLogin2">
            <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
          </el-input>
          <div class="login-code">
            <!-- <img :src="codeUrl" @click="getCode" class="login-code-img" /> -->
            <div class="code-btn" v-if="countdown < 0" @click="getPhoneCode">获取验证码</div>
            <div class="countdown" v-else>{{ countdown }}s</div>
          </div>
        </el-form-item>
        <el-form-item style="width:100%;">
          <el-button :loading="loading" size="medium" type="primary" style="width:100%;"
            @click.native.prevent="handleLogin2">
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>
          <div style="float: right;" v-if="register">
            <router-link class="link-type" :to="'/register'">立即注册</router-link>
          </div>
        </el-form-item>
      </el-form>
      <!--  底部  -->
      <div class="el-login-footer">
        <span>Copyright © 2018-2023 ruoyi.vip All Rights Reserved.</span>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/styles/element-variables.scss'
import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import { getCodeImg, getPhoneCode,loginPhone} from "@/api/login";
import Cookies from "js-cookie";
import { encrypt, decrypt } from '@/util/jsencrypt'
import {  setToken } from '@/util/auth'
import {Message} from "element-ui";

export default {
  name: "login",
  data() {
    return {
      codeUrl: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: ""
      },
      loginForm2: {
        phonenumber: "",
        code: "",
        uuid: ""
      },
      countdown: -1,
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" }
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" }
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }]
      },
      loginRules2: {
        phonenumber: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }]
      },
      loading: false,
      // 验证码开关
      captchaEnabled: true,
      // 注册开关
      register: false,
      redirect: undefined,
      loginType: 2,
      timerInterval: null,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created() {
    this.getCode();
    this.getCookie();
  },
  methods: {
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.data.img;
          this.loginForm.uuid = res.data.uuid;
        }
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    handleLogin() {
      let _this = this;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 });
            Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove('rememberMe');
          }
          _this.$store.dispatch("user/Login", _this.loginForm)
              .then((user) => {
                const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/profile.jpg") : user.avatar;
                _this.$store.commit('user/SET_NAME', user.username)
                _this.$store.commit('user/SET_NICK_NAME', user.nickName)
                _this.$store.commit('user/SET_AVATAR', avatar)
                _this.$store.commit('user/SET_USERID',user.userId)
                _this.$store.commit('user/SET_ADMIN_ROLE', user.adminRole)
            _this.$router.push({ path: this.redirect || "/" }).catch(() => { });
          }).catch(() => {
            _this.loading = false;
            if (_this.captchaEnabled) {
              _this.getCode();
            }
          });
        }
      });
    },
    changeLoginType(type) {
      this.loginType = type
    },
    handleLogin2() {
      let _this = this;
      this.$refs.loginForm2.validate(valid => {
        console.log(valid)
        if(valid){
          let data ={
            phoneNumber:this.loginForm2.phonenumber,
            code:this.loginForm2.code
          }
          _this.loading = true;
          loginPhone(data).then(res=>{
            if (res.ok) {
              setToken(res.token)
              this.$store.commit('SET_TOKEN', res.token)
              this.loading = false;
              this.$router.push({path: this.redirect || "/"}).catch(() => {
              });
            } else {
              Message({message: res.msg, type: 'error'});
              this.loading = false;

            }
          }).catch((e) => {
            _this.loading = false;
          })
        }
      })
    },
    getPhoneCode() {
      let phone = this.loginForm2.phonenumber
      if (phone.length == 11) {
        this.countdown = 60
        clearInterval(this.timerInterval)
        this.timerInterval = setInterval(() => {
          this.countdown--
        }, 1000)

        getPhoneCode({ phone }).then(res => {
          console.log(res)
          this.$modal.msgSuccess("验证码已发送");
        })
      } else {
        this.$modal.msgSuccess("请正确输入手机号码");

      }

    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url("../assets/login-background.jpg");
  background-size: cover;
}

.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;

  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.login-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }

  .code-btn {
    // width: 33%;
    height: 38px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    background: #1890ff;
    cursor: pointer;
    vertical-align: middle;
  }

  .countdown {
    color: #bfbfbf;
    font-size: 14px;
    text-align: center;

  }
}

.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}

.login-code-img {
  height: 38px;
}

.login-flex {
  display: flex;

  .login-type {
    width: 50%;
    text-align: center;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e3e4e5;
    font-size: 14px;
    cursor: pointer;

  }

  .loginactive {
    border-bottom: 1px solid #1890ff;
    color: #1890ff;
  }

}
</style>
